import { Maybe } from 'maybe-not';
import SDKMessageBus from '../utility/message-bus';
import { IDict } from '../types/utility';

export interface IExtensionRequestBody {
    route: string;
    body?: IDict<any>;
}

export interface IExtensionResponse<T> {
    data: T;
    status: number;
    statusText: string;
}

export default function requestExtensionData(
    messageBus: SDKMessageBus,
    platformCapabilities: Set<string>,
    moduleId: string
) {
    if (!platformCapabilities.has('requestExtensionData')) {
        return;
    }

    return function<R>(requestOptions: IExtensionRequestBody): Promise<IExtensionResponse<R>> {
        return messageBus
            .sendRequest<IExtensionResponse<R>>(
                `requestExtensionData`,
                Maybe.just(JSON.stringify({ moduleId, ...requestOptions }))
            )
            .then(response => {
                if (response.value.status >= 200 && response.value.status < 300) {
                    // positive response for any 2XX series response
                    return response.value;
                }

                throw response.value;
            });
    };
}
